import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { findAllImage, findAllServicePage, findSpecificServicePage } from "../../api/apiService";
import listIcon from "../../assets/a3.webp";
import servicesData from "../../data/servicesData";
import Cards from "./Cards";

const ServicePage = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();
  const service = servicesData[serviceId];

  const trackRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [servicessData, setServicessData] = useState([]);
  const getData = async () => {
    const data = await findSpecificServicePage(serviceId);
    const newData = data?.data?.[0] || {};
    const renderAllImage = async (id) => {
      if (!id) return [];
      const idArray = Array.isArray(id) ? id : [id];
      const idsParam = idArray.join(",");
      const res = await findAllImage(idsParam);
      return res?.data?.[0]?.data || [];
    };
    let newImgData
    // Wait for all images to resolve
    if (newData?.sectionData?.image) {
      newImgData = await renderAllImage(newData?.sectionData?.image);
    }
    setServicessData({
      ...newData,
      sectionData: {
        ...newData?.sectionData,
        ...newImgData && { image: newImgData }
      },
    });
  }

  useEffect(() => {
    getData();
  }, [serviceId])
  const checkScrollability = () => {
    if (trackRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = trackRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  const scrollLeft = () => {
    if (trackRef.current) {
      const firstChild = trackRef.current.firstElementChild;
      const secondChild = trackRef.current.children[1];
      // Calculate actual gap between cards
      const gap = secondChild ? secondChild.offsetLeft - (firstChild.offsetLeft + firstChild.offsetWidth) : (window.innerWidth >= 768 ? 24 : 16);
      const scrollAmount = firstChild ? firstChild.offsetWidth + gap : 300;
      trackRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      setTimeout(checkScrollability, 300);
    }
  };

  const scrollRight = () => {
    if (trackRef.current) {
      const firstChild = trackRef.current.firstElementChild;
      const secondChild = trackRef.current.children[1];
      // Calculate actual gap between cards
      const gap = secondChild ? secondChild.offsetLeft - (firstChild.offsetLeft + firstChild.offsetWidth) : (window.innerWidth >= 768 ? 24 : 16);
      const scrollAmount = firstChild ? firstChild.offsetWidth + gap : 300;
      trackRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      setTimeout(checkScrollability, 300);
    }
  };

  useEffect(() => {
    checkScrollability();
    const handleResize = () => checkScrollability();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [serviceId]);

  const [newServiceId, setNewServiceId] = useState([])
  const findData = async () => {
    const res = await findAllServicePage();
    const newDat = res?.data?.map((item) => item?.slug) || [];
    setNewServiceId(newDat);
  }

  useEffect(() => {
    findData();
  }, [])
  const currentIndex = newServiceId.indexOf(serviceId);
  const previousServiceId = currentIndex > 0 ? newServiceId[currentIndex - 1] : null;
  const nextServiceId = currentIndex < newServiceId.length - 1 ? newServiceId[currentIndex + 1] : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceId]);

  if (!servicessData) {
    return (
      <div className="container mx-auto px-4 py-10">
        <h1 className="text-2xl font-bold text-center text-red-500">
          Service not found
        </h1>
      </div>
    );
  }

  const { title, description, highlights, icon, heading } = servicessData;

  return (
    <section className="text-normal md:py-10 px-4 md:px-16">
      <div className="flex justify-between items-center max-w-sm md:max-w-5xl mx-auto mt-12 md:mt-16 mb-8 px-4">
        <button
          onClick={() => previousServiceId && navigate(`/services/${previousServiceId}`)}
          disabled={!previousServiceId}
          className={`flex items-center gap-2 border border-[#F37934] text-[#F37934] px-3 py-2 font-bold rounded transition-all duration-300 ${previousServiceId
            ? "bg-[#F37934] text-white hover:bg-[#d66a2d] hover:scale-105 cursor-pointer"
            : " text-[#F37934] cursor-not-allowed "
            }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>

          {/* Show text only on medium screens and up */}
          <span className="hidden md:inline">Previous</span>
        </button>

        {/* Title */}
        <div className="flex justify-center items-center">
          <h1
            className="text-lg md:text-3xl font-bold text-center text-[#F37934] uppercase whitespace-pre-line"
            data-aos="zoom-in"
            data-aos-duration="800"
            data-aos-easing="ease-out"
          >
            {servicessData?.heading}
          </h1>
        </div>

        {/* Next Button */}
        <button
          onClick={() => nextServiceId && navigate(`/services/${nextServiceId}`)}
          disabled={!nextServiceId}
          className={`flex items-center gap-2 border border-[#F37934] text-[#F37934] px-3 py-2 font-bold rounded transition-all duration-300 ${nextServiceId
            ? "bg-[#F37934] text-white hover:bg-[#d66a2d] hover:scale-105 cursor-pointer"
            : "text-[#F37934] cursor-not-allowed"
            }`}
        >
          {/* Show text only on medium screens and up */}
          <span className="hidden md:inline">Next</span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      {/* Description */}
      {servicessData?.content &&
        <p className="text-center font-quicksand text-[#56453F] max-w-2xl md:max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed text-sm md:text-base">
          <div dangerouslySetInnerHTML={{ __html: servicessData?.content }} />
          {/* {servicessData?.content} */}
        </p>
      }
      {servicessData?.sectionData?.enable_images &&
        <div
          className="flex items-center justify-center gap-4 md:gap-8 max-w-3xl md:max-w-6xl mx-auto mb-12"
        >
          {/* Left Navigation Button - Outside images */}
          <button
            onClick={scrollLeft}
            disabled={!canScrollLeft}
            className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 border-3 rounded-lg flex items-center justify-center transition-all duration-300 group shadow-md ${canScrollLeft
              ? "border-[#F37934] bg-white hover:bg-[#F37934] cursor-pointer"
              : "border-gray-300 bg-gray-100 cursor-not-allowed opacity-50"
              }`}
            aria-label="Previous"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={`h-5 w-5 md:h-6 md:w-6 ${canScrollLeft
                ? "text-[#F37934] group-hover:text-white"
                : "text-gray-400"
                }`}
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button>

          <div className="overflow-hidden flex-1">
            <div
              ref={trackRef}
              className="flex gap-4 md:gap-6 overflow-x-auto scroll-smooth scrollbar-hide "
              style={{ scrollBehavior: 'smooth' }}
              onScroll={checkScrollability}
            >
              {servicessData?.sectionData?.image?.map((img, i) => (
                <div
                  key={i}
                  className="bg-gradient-to-br from-[#F0F0E5] via-[#FFFFFF] to-[#F0F0E5] border border-white rounded-2xl p-2 md:p-3 flex-shrink-0 w-full md:w-80"
                >
                  <img
                    src={img}
                    alt={`carousel-img-${i}`}
                    className="w-full h-48 md:h-56 object-cover rounded-xl"
                    loading="eager"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Right Navigation Button - Outside images */}
          <button
            onClick={scrollRight}
            disabled={!canScrollRight}
            className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 border-3 rounded-lg flex items-center justify-center transition-all duration-300 group shadow-md ${canScrollRight
              ? "border-[#F37934] bg-white hover:bg-[#F37934] cursor-pointer"
              : "border-gray-300 bg-gray-100 cursor-not-allowed opacity-50"
              }`}
            aria-label="Next"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={`h-5 w-5 md:h-6 md:w-6 ${canScrollRight
                ? "text-[#F37934] group-hover:text-white"
                : "text-gray-400"
                }`}
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      }
      {servicessData.sectionData?.enable_div &&
        <div className="mt-12 md:mt-16 relative">
          <div className="max-w-sm md:max-w-3xl mx-auto bg-gradient-to-br from-[#F0F0E5] via-[#FFFFFF] to-[#F0F0E5] border border-white rounded-2xl p-6 md:p-16 font-quicksand leading-relaxed relative">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">

              <h2 className="block w-full max-w-xs md:max-w-md text-base md:text-2xl px-6 font-bold py-1 md:py-2 mx-auto text-center text-white bg-[#56453F] rounded-full"
                data-aos="zoom-in"
                data-aos-duration="800"
                data-aos-easing="ease-out">
                {servicessData.sectionData.ourApproaches?.heading}
              </h2>

            </div>
            {servicessData.sectionData.ourApproaches?.content && (
              <p className="my-4 md:mb-6 text-center whitespace-pre-line text-sm md:text-base">
                <div dangerouslySetInnerHTML={{ __html: servicessData.sectionData.ourApproaches?.content }} />
              </p>
            )}
          </div>
        </div>
      }

      {/* Sections */}
      {service?.sections?.map((section, idx) => {
        switch (section.type) {
          case "cards":
            return (
              <div key={idx} className="mt-12 md:mt-16">
                <h2 className="text-xl md:text-3xl font-bold text-center text-[#F37934] mb-6 md:mb-10"
                  data-aos="zoom-in"
                  data-aos-duration="800"
                  data-aos-easing="ease-out">
                  {section.heading}
                </h2>
                <div
                  className={`grid gap-6 justify-center max-w-full md:max-w-4xl mx-auto ${section.cards.length === 3
                    ? "grid-cols-1 md:grid-cols-3"
                    : "grid-cols-1 md:grid-cols-2 gap-y-12 md:gap-y-24"
                    }`}
                >

                  {section?.cards?.map((card, i) => (
                    <div
                      key={i}
                      className={`p-4 md:p-6 rounded-2xl border-2 border-white flex flex-col justify-start text-left
                        ${section.cards.length === 3 ? "w-full md:w-[280px]" : "w-[full] md:w-[300px] lg:w-[360px]"} 
                        min-h-[200px] md:min-h-[220px]`}
                      style={{
                        background:
                          "linear-gradient(to bottom right, #F0F0E5, #FFFFFF, #F0F0E5)",
                      }}
                    >
                      <img src={card.icon} alt="icon" className="w-10 h-10 md:w-14 md:h-14 mb-2 md:mb-3" />
                      <h3 className="font-bold text-base md:text-lg text-[#56453F] mb-2">
                        {card.title}
                      </h3>
                      <p className="text-sm md:text-base text-[#56453F]">{card.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            );

          default:
            return null;
        }
      })}

      {servicessData?.sectionData?.enable_cards &&
        <div className="mt-12 md:mt-16">
          <h2 className="text-xl md:text-3xl font-bold text-center text-[#F37934] mb-6 md:mb-10"
            data-aos="zoom-in"
            data-aos-duration="800"
            data-aos-easing="ease-out">
            {servicessData?.sectionData?.cards?.heading}
          </h2>
          <Cards data={servicessData?.sectionData?.cards} />
        </div>
      }
      {servicessData?.sectionData?.enable_cards_1 &&
        <div className="mt-12 md:mt-16">
          <h2 className="text-xl md:text-3xl font-bold text-center text-[#F37934] mb-6 md:mb-10"
            data-aos="zoom-in"
            data-aos-duration="800"
            data-aos-easing="ease-out">
            {servicessData?.sectionData?.cards1?.heading}
          </h2>
          <Cards data={servicessData?.sectionData?.cards1} />
        </div>
      }
      {servicessData?.sectionData?.enable_what_we_offer && (
        <div className="space-y-4 md:space-y-6 font-quicksand text-[#56453F] max-w-sm md:max-w-3xl p-3 md:p-4 py-8 md:py-10 mx-auto">
          <h2 className="text-xl md:text-3xl pt-4 md:pt-6 font-bold text-center text-[#F37934] my-6 md:my-10 uppercase"
            data-aos="zoom-in"
            data-aos-duration="800"
            data-aos-easing="ease-out">
            {servicessData?.sectionData?.what_we_offer?.heading}
          </h2>
          {servicessData?.sectionData?.what_we_offer?.data?.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-xl border-2 border-white"
              style={{
                background:
                  "linear-gradient(to bottom right, #F0F0E5, #FFFFFF, #F0F0E5)",
              }}
            >
              <div className="flex items-center justify-center flex-shrink-0">
                <img src={listIcon} alt="service icon" className="w-8 h-8 md:w-10 md:h-10" />
              </div>
              <p className="text-sm md:text-base">{item.content}</p>
            </div>
          ))}
        </div>
      )}
      {servicessData?.sectionData?.enable_why_choose_us && (
        <div className="mt-12 md:mt-16">
          <h2 className="text-xl md:text-3xl font-bold text-center text-[#F37934] mb-4 md:mb-6 uppercase"
            data-aos="zoom-in"
            data-aos-duration="800"
            data-aos-easing="ease-out">
            {servicessData?.sectionData?.why_choose_us?.heading}
          </h2>
          <p className="text-center font-quicksand text-[#56453F] max-w-sm md:max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed text-sm md:text-base">
            {servicessData?.sectionData?.content}
            <div dangerouslySetInnerHTML={{ __html: servicessData?.sectionData?.why_choose_us?.content }} />
          </p>
        </div>
      )}


    </section>
  );
};

export default ServicePage;
